/*
 * Project: forca
 * File Created: Wednesday, 15th September 2021 8:03:51 am
 * Author: Teodor Moquist (teodor@moquist.dk)
 */

const validateNoEmpty = /(.|\s)*\S(.|\s)*/;
const validateName = /^[^0-9!#¤%&()=?{}€$£@´`\'*.,;:_<>½/]+$/;
const validateEmail = /^[ÆØÅæøåa-zA-Z0-9.!#$%&\'*+\/=?^_`{|}~-]+@[ÆØÅæøåa-zA-Z0-9](?:[ÆØÅæøåa-zA-Z0-9-]{0,61}[ÆØÅæøåa-zA-Z0-9])?(\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+/;
const validateTelephone = /^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\. /0-9]{7,16}$/;
const validateOnlyNumbers = /^[0-9]+$/;
const validateCpr = /^(\d{6}-\d{4})|^(\d{10})$/;
const validateSalery = /0*[1-9][0-9]*(\.[0-9]+)?/;
const validateEmailwithDomain = /[ÆØÅæøåa-zA-Z0-9.!#$%&\'*+\/=?^_`{|}~-]+@[ÆØÅæøåa-zA-Z0-9-]+(\.[a-zA-Z]{2,})+/;

const makeRegexToPattern = (regex: RegExp) => {
	// make regex into a string
	let pattern = regex.toString();

	// remove first char (/)
	pattern = pattern.substring(1);

	// remove last char (/)
	pattern = pattern.slice(0, -1);

	return pattern;
};

// for functions like .match() and .test()
export const formConfig = {
	empty: validateNoEmpty,
	name: validateName,
	email: validateEmail,
	telephone: validateTelephone,
	onlyNumbers: validateOnlyNumbers,
	cprNumber: validateCpr,
	salery: validateSalery,
	emailDomain: validateEmailwithDomain
};

// for inputs files patterns
export const formConfigPattern = {
	empty: makeRegexToPattern(formConfig.empty),
	name: makeRegexToPattern(formConfig.name),
	email: makeRegexToPattern(formConfig.email),
	telephone: makeRegexToPattern(formConfig.telephone),
	onlyNumbers: makeRegexToPattern(formConfig.onlyNumbers),
	cprNumber: makeRegexToPattern(formConfig.cprNumber),
	salery: makeRegexToPattern(formConfig.salery),
	emailDomain: makeRegexToPattern(formConfig.emailDomain)
};